import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AuthorCollectingSocietyView } from "./AuthorCollectingSocietyView";
import { AuthorCollectingSocietyViewStore } from "../../store/AuthorCollectingSocietyViewStore";
import { useStore } from "../../../../hooks";

export const AuthorCollectingSocietyViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/authorCollectingSociety/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AuthorCollectingSocietyViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AuthorCollectingSocietyView authorCollectingSocietyViewStore={store} />
      </PageLayout>
    </div>
  );
});
